import React from 'react';
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';

const FetchLoading = () => {
  return (
    <Box my={3}>
      <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress
          sx={{
            height: '10px',
            bgcolor: 'var(--yello-color)',
            color: 'var(--yello-color)',
            borderRadius: '10px',
          }}
        />
        <LinearProgress
          color="success"
          sx={{ height: '10px', borderRadius: '10px' }}
        />
        <LinearProgress
          color="inherit"
          sx={{ height: '10px', borderRadius: '10px' }}
        />
      </Stack>
    </Box>
  );
};

export default FetchLoading;
